import React from "react";
import RestrictedOperatorsContent from "../components/opi/opi-content";

const RestrictedOperators = () => {
  return <RestrictedOperatorsContent isRestricted/>;
};

export default RestrictedOperators;
